
import React, { useEffect } from 'react';

import Table from "./partials/Table";
import RewardCalcAutoToggle from "../../../components/RewardCalcAutoToggle";

export default () => {

  useEffect(() => {
    document.title = "Kết quả Max3D"
  }, []);

  return (
    <>
      <RewardCalcAutoToggle gameId="max3d" gameName="Max3D" />

      <Table />
    </>
  );
};
